<template>
    <Upload
        :action="uploadUrl"
        :name="name"
        :headers="setHeaders"
        :data="data"
        :multiple="multiple"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :show-upload-list="showUploadList"
        :format="format"
        :on-format-error="formatError"
    >
            <slot></slot>
    </Upload>
</template>

<script type="text/ecmascript-6">
import { getToken } from '@/utils/auth.js';
import {getBaseUrl} from "../../utils/public";

export default {
    name: 'UPLOAD',
    props:{
        data:{
            type:Object,
            default:null
        },
        name:{
            type:String,
            default:'file'
        },
        action:{
            type:String,
            default:''
        },
        showUploadList:{
            type:Boolean,
            default:false
        },
        multiple:{
            type:Boolean,
            default:false
        },
      format:{
          type:Array,
        defalut:()=>{return []}
      }
    },
    computed: {
        setHeaders() {
            return {'Access-Token':getToken()}
        },
        uploadUrl() {
            return `${getBaseUrl()+this.action}`
        }
    },
    methods: {
        uploadSuccess( res, file, fileList){
            console.log(res, file, fileList);
            if(res.code === 0){
                this.$emit('uploadSuccess',res,file)
            }else{
                this.$Message.error({
                    content:res.message || '上传失败！'
                })
            }

        },
        uploadError() {

        },
      formatError(){
        this.$Message.info('支持的文件类型：'+this.format.join('、'))


      }
    }
}
</script>
